<template>
  <div>
    <form @submit.prevent="handleSubmit" v-if="form">
      <div class="columns">
        <div class="column">
          <b-field :label="$tc('banner._name')">
            <b-input v-model="form.banner_name" placeholder="Banner name"></b-input>
          </b-field>
        </div>

        <div class="column">
          <b-field label="Must view seconds">
            <b-input v-model="form.must_view_seconds" placeholder="Секунд"></b-input>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <b-field label="Duration in seconds">
            <b-input v-model="form.duration" placeholder="Секунд"></b-input>
          </b-field>
        </div>

        <div class="column">
          <b-field style="padding-top: 2rem;">
            <b-switch v-model="form.close_on_end">Auto close on end</b-switch>
          </b-field>
        </div>
      </div>

      <b-field style="margin-bottom: 1.5rem;">
        <b-switch v-model="form.is_active">Ads is active</b-switch>
      </b-field>

      <button class="button is-primary" :class="{ 'is-loading': form.processing }">Save</button>
    </form>
  </div>
</template>

<script>
export default {
  props: ["position"],

  data() {
    return {
      popup: null,

      form: null
    };
  },

  created() {
    this.load();
  },

  watch: {
    popup(popup) {
      this.form = new window.Form({
        must_view_seconds: popup.must_view_seconds
          ? popup.must_view_seconds
          : 4,
        duration: popup.duration ? popup.duration : 30,
        close_on_end: !!popup.close_on_end,
        is_active: !!popup.is_active,
        banner_name: popup.banner ? popup.banner.name : ""
      });
    }
  },

  methods: {
    load() {
      this.$http
        .get(`/admin/api/marketing/popups/${this.position}`)
        .then(response => {
          this.popup = response.data.data;
        });
    },

    handleSubmit() {
      this.form
        .put(`/admin/api/marketing/popups/${this.position}`)
        .then(response => {
          this.$buefy.toast.open(response.data.message);
        });
    }
  }
};
</script>
